import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
//
// Tokens
//
export const CFBaseActionFooterTokens = {
    MAX_INLINE_ITEMS: 2,
};
//
// Helpers
//
export const CFBaseActionFooterHelpers = {
    alignment: ({ inlineLayout }) => inlineLayout
        ? css `
          flex-direction: row;
          align-items: center;
          justify-content: center;
          gap: ${CFTokens.SPACER.B}px;
        `
        : css `
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          gap: ${CFTokens.SPACER.C}px;
        `,
};
//
// Utilities
//
export const CFBaseActionFooterUtilities = {
    isLayoutInline: (numItems, stackAlways) => !stackAlways && numItems <= CFBaseActionFooterTokens.MAX_INLINE_ITEMS,
};
//
// Element Styles
//
export const CFBaseActionFooterStyles = {
    Actions: css `
    display: flex;
    justify-content: flex-end;
    ${CFBaseActionFooterHelpers.alignment}
  `,
    ActionsWeb: css `
    @media ${CFTokens.WEB_BREAKPOINT_QUERIES['sm-up']} {
      flex-direction: row;
      gap: ${CFTokens.SPACER.D}px;
    }
  `,
    Content: css `
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  `,
    ContentWeb: css `
    @media ${CFTokens.WEB_BREAKPOINT_QUERIES['sm-up']} {
      flex: 1;
      align-items: flex-start;
    }
  `,
    Root: css `
    box-sizing: border-box;
    padding: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${CFTokens.SPACER.C}px;
  `,
    RootWeb: css `
    @media ${CFTokens.WEB_BREAKPOINT_QUERIES['sm-up']} {
      flex-direction: row-reverse;
      justify-content: space-between;
      gap: ${CFTokens.SPACER.D}px;
    }
  `,
};
